exports.getLocale = function (messages, Wix) {
  const l = Wix.Utils.getLocale()
  if (messages[l] !== undefined) {
    console.log('setting locale to ' + l)
    return l
  } else {
    console.log('locale ' + l + ' not present, using default')
    return 'en'
  }
}
